/**
 * Sunrise / sunset / civil twilight in UTC — the USNO algorithm.
 * Accuracy is a few minutes, which is what the SS field on the form needs.
 * All inputs are plain numbers so this runs anywhere.
 */
const RAD = Math.PI / 180;
/** Zenith angles: official sunrise/sunset 90.833°, civil twilight 96°. */
export const ZENITH = { official: 90.833, civil: 96, nautical: 102, astronomical: 108 };
/**
 * Minutes after 00:00 UTC of the given date at which the sun crosses `zenith`.
 * `rise` = true for the morning event. Returns null when the event does not
 * occur (polar day/night at that zenith).
 */
export function sunEventUTC(y, mo, d, lat, lon, rise, zenith) {
    const N1 = Math.floor((275 * mo) / 9);
    const N2 = Math.floor((mo + 9) / 12);
    const N3 = 1 + Math.floor((y - 4 * Math.floor(y / 4) + 2) / 3);
    const N = N1 - N2 * N3 + d - 30; // day of year
    const lngHour = lon / 15;
    const t = N + ((rise ? 6 : 18) - lngHour) / 24;
    const M = 0.9856 * t - 3.289;
    let L = M + 1.916 * Math.sin(M * RAD) + 0.02 * Math.sin(2 * M * RAD) + 282.634;
    L = ((L % 360) + 360) % 360;
    let RA = Math.atan(0.91764 * Math.tan(L * RAD)) / RAD;
    RA = ((RA % 360) + 360) % 360;
    RA += Math.floor(L / 90) * 90 - Math.floor(RA / 90) * 90;
    RA /= 15;
    const sinDec = 0.39782 * Math.sin(L * RAD);
    const cosDec = Math.cos(Math.asin(sinDec));
    const cosH = (Math.cos(zenith * RAD) - sinDec * Math.sin(lat * RAD)) / (cosDec * Math.cos(lat * RAD));
    if (cosH > 1 || cosH < -1)
        return null;
    let H = rise ? 360 - Math.acos(cosH) / RAD : Math.acos(cosH) / RAD;
    H /= 15;
    const T = H + RA - 0.06571 * t - 6.622;
    const UT = (((T - lngHour) % 24) + 24) % 24;
    return Math.round(UT * 60);
}
export function sunTimes(y, mo, d, lat, lon) {
    return {
        sunriseMin: sunEventUTC(y, mo, d, lat, lon, true, ZENITH.official),
        sunsetMin: sunEventUTC(y, mo, d, lat, lon, false, ZENITH.official),
        civilDawnMin: sunEventUTC(y, mo, d, lat, lon, true, ZENITH.civil),
        civilDuskMin: sunEventUTC(y, mo, d, lat, lon, false, ZENITH.civil),
    };
}
/** Validate a calendar date strictly (rejects 14.13.2026 and 31.02.2026). */
export function isValidDate(y, mo, d) {
    if (!Number.isInteger(y) || !Number.isInteger(mo) || !Number.isInteger(d))
        return false;
    const chk = new Date(Date.UTC(y, mo - 1, d));
    return chk.getUTCFullYear() === y && chk.getUTCMonth() === mo - 1 && chk.getUTCDate() === d;
}
//# sourceMappingURL=sun.js.map